import { postFetch } from '../fetch';

import { apiConfig } from '../config';

interface PostResetStudentLoginResponse {
    login: string;
    code: string;
}

export function postResetStudentLogin(
    studentId: number
): Promise<PostResetStudentLoginResponse> {
    const { apiPostResetStudentLogin } = apiConfig.getStaticUrls();

    return postFetch(`${apiPostResetStudentLogin}${studentId}`);
}
